const roundToGivenDecimals = (
  value: number,
  decimals = 2,
): number => Math.round((value + Number.EPSILON) * Math.pow(10, decimals)) / Math.pow(10, decimals);

export default roundToGivenDecimals;
